//* ----------------------------------------
//window実行
//--------------------------------------- */
import Masonry from 'masonry-layout';
import 'slick-carousel';
////// ロード時
$(window).on('load', function () {
  //全ての写真を表示をクリック
  $('#openModal').on('click', function () {
    $('.posLightbox').addClass('open');
    $('#photoModal').animate({
      scrollTop: 0
    }, 0);
  });

  //メインビジュアルクリック
  $('.conceptPhotos').find('img').on('click', function () {
    let result = $(this).data('scr');
    $('.posLightbox').addClass('open');
    let isPosition = $('#' + result).position();
    $('#photoModal').animate({
      scrollTop: isPosition.top - 20
    }, 10);
  });

  //閉じるボタン
  $('.closeBtn').on('click', function () {
    let thisText = $(this).find('span').text();
    if (thisText == '閉じる') {
      $('.posLightbox').removeClass('open');
      $('#photoModal').animate({
        scrollTop: 50
      }, 0);
    } else {
      $('.modalContainer').removeClass('open');
      $('.repeatarea').removeClass('noDisp');
      $('#photoModal').removeClass('noOver');
      $(this).find('span').text('閉じる');
    }
  });

  let msnry = new Masonry('.repeatarea', {
    itemSelector: '.repeatEle',
    columnWidth: '.repeatEle',
    fitWidth: true,
    horizontalOrder: true,
  });

  $(".mainSlide").slick({
    arrows: true,
    infinite: true,
    asNavFor: ".thumbnail",
  });
  $(".thumbnail").slick({
    arrows: false,
    autoplay: false,
    slidesToShow: 5,
    asNavFor: ".mainSlide",
    focusOnSelect: true,
  });

  //一覧写真クリック
  $('.repeatEle').on('click', function () {
    let index = $(this).index();
    $('.closeBtn').find('span').text('一覧へ戻る');
    $('#photoModal').animate({
      scrollTop: 0
    }, 0);
    $('.modalContainer').addClass('open');
    $('.repeatarea').addClass('noDisp');
    $('#photoModal').addClass('noOver');
    $('.mainSlide').slick('slickGoTo', index, false);
  });
  
  $(".spMode").slick({
    arrows: true,
    infinite: true,
  });
  
});